export default __webpack_public_path__ + "static/media/mas.b555a636.svg";